import React from "react"
import FilterSection from "../FilterSection"
import FilterOptionGroup from "../FilterOptionGroup"
import Checkbox from "../Checkbox"
import { RotateCcw } from "lucide-react"
import { colorForSource } from "../../utils/parsers/source"

const FilterBody = ({
  meta,
  filters,
  toggle,
  setMaxPrice,
  setOnlyGuaranteed,
  onReset,
  activeCount,
}) => {
  return (
    <div>
      <div className="flex items-center justify-between pb-3 border-b border-[#E7EAEF]">
        <span className="text-sm font-medium text-[#26303D]">
          Filters {activeCount > 0 && <span className="text-[#FF6B3D]">({activeCount})</span>}
        </span>
        <button
          onClick={onReset}
          className="flex items-center gap-1 text-xs text-[#7C8697] hover:text-[#FF6B3D]"
        >
          <RotateCcw size={12} /> Reset
        </button>
      </div>

      <FilterOptionGroup
        title="Provider"
        options={meta.sources}
        selected={filters.sources}
        onToggle={(v) => toggle("sources", v)}
        renderLabel={(sourceName) => (
          <span className="inline-flex items-center gap-1.5">
            <span
              className="w-2 h-2 rounded-full shrink-0"
              style={{ backgroundColor: colorForSource(sourceName) }}
            />
            {sourceName}
          </span>
        )}
      />

      <FilterOptionGroup
        title="Stars"
        options={meta.stars}
        selected={filters.stars}
        onToggle={(v) => toggle("stars", v)}
      />

      <FilterOptionGroup
        title="Meal plan"
        options={meta.mealPlans}
        selected={filters.mealPlans}
        onToggle={(v) => toggle("mealPlans", v)}
      />

      <FilterOptionGroup
        title="Resort"
        options={meta.resorts}
        selected={filters.resorts}
        onToggle={(v) => toggle("resorts", v)}
      />

      {/* <FilterSection title="Max price">
        <div className="flex items-center justify-between text-xs text-[#5A6779] mb-2">
          <span>{meta.priceMin} €</span>
          <span className="font-mono font-medium text-[#26303D]">
            up to {filters.maxPrice ?? meta.priceMax} €
          </span>
          <span>{meta.priceMax} €</span>
        </div>
        <input
          type="range"
          min={meta.priceMin}
          max={meta.priceMax}
          step={5}
          value={filters.maxPrice ?? meta.priceMax}
          onChange={(e) => setMaxPrice(Number(e.target.value))}
          className="w-full accent-[#FF6B3D]"
        />
      </FilterSection> */}

      {/* <FilterSection title="Availability">
        <Checkbox checked={filters.onlyGuaranteed} onChange={() => setOnlyGuaranteed((v) => !v)}>
          Guaranteed only
        </Checkbox>
      </FilterSection> */}
    </div>
  )
}

export default FilterBody
